var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditBox({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1716 1.9981L6.1943 6.97539L6.19924 9.80679L9.02467 9.80186L14 4.82652V13.3315C14 13.6996 13.7015 13.9981 13.3333 13.9981H2.66667C2.29848 13.9981 2 13.6996 2 13.3315V2.66476C2 2.29658 2.29848 1.9981 2.66667 1.9981H11.1716ZM13.6569 1.39844L14.5997 2.34124L8.4714 8.46952L7.53027 8.47112L7.5286 7.52672L13.6569 1.39844Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBox);
export default __webpack_public_path__ + "static/media/edit-box.4107ea5d1ace1d10bc06167af8ef2eec.svg";
export { ForwardRef as ReactComponent };